import { z } from 'zod';
export const SerializableVideoSlotSchema = z.object({
    id: z.string().min(1),
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
    width: z.number().min(0).max(1),
    height: z.number().min(0).max(1),
    sourceId: z.string().optional(),
    zIndex: z.number().int().default(0),
});
export const SerializableSceneSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1).max(68),
    layoutId: z.string().default('auto'),
    videoSlots: z.array(SerializableVideoSlotSchema),
    backgroundColor: z.string().optional(),
    backgroundSourceId: z.string().optional(),
});
function generateUUID() {
    try {
        return crypto.randomUUID();
    }
    catch (_) { }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export function generateSceneId() {
    return generateUUID();
}
export function generateVideoSlotId() {
    return generateUUID();
}
export function createDefaultSerializableVideoSlot() {
    return {
        id: generateVideoSlotId(),
        x: 0.25,
        y: 0.25,
        width: 0.5,
        height: 0.5,
        zIndex: 0,
    };
}
export function createDefaultSerializableScene(name = 'Scene 1', id = generateSceneId()) {
    return {
        id,
        name,
        layoutId: 'auto',
        videoSlots: [
            {
                id: generateVideoSlotId(),
                x: 0,
                y: 0,
                width: 1,
                height: 1,
                zIndex: 0,
            },
        ],
    };
}
